import { GlDisclosureDropdownItem, GlToggle } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { persistMetadataPreference, alertPreferenceError } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/list/display_settings_preferences.js?vue3';
export default {
    name: 'WorkItemDisplaySettingsEmptyGroups',
    components: {
        GlDisclosureDropdownItem,
        GlToggle
    },
    mixins: [
        InternalEvents.mixin()
    ],
    i18n: {
        showEmptyGroups: s__('WorkItems|Show empty groups')
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemTypeId: {
            type: String,
            required: true
        },
        sortKey: {
            type: String,
            required: false,
            default: ''
        },
        namespacePreferences: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        isSavedView: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'update-settings'
    ],
    data () {
        return {
            isLoading: false
        };
    },
    computed: {
        showEmptyGroups () {
            return this.namespacePreferences.showEmptyGroups ?? true;
        }
    },
    methods: {
        async toggleShowEmptyGroups () {
            const showEmptyGroups = !this.showEmptyGroups;
            const input = {
                ...this.namespacePreferences,
                showEmptyGroups
            };
            this.trackEvent('configure_columns_on_work_item_board', {
                label: showEmptyGroups ? 'show_empty_groups' : 'hide_empty_groups'
            });
            if (this.isSavedView) {
                this.$emit('update-settings', input);
                return;
            }
            this.isLoading = true;
            try {
                await persistMetadataPreference({
                    apolloClient: this.$apollo,
                    namespace: this.fullPath,
                    workItemTypeId: this.workItemTypeId,
                    userPreferencesOnly: false,
                    displaySettings: input,
                    sort: this.sortKey
                });
            } catch (error) {
                alertPreferenceError(error);
            } finally{
                this.isLoading = false;
            }
        }
    }
};
